export default __webpack_public_path__ + "static/media/icon_home.4d85f38c.svg";